import EventBus from "./services/event-bus";
import ClientService from './services/client-service';
import ShopService from './services/shop-service';

angular.module('eatself')
	.constant('ADMIN',false)
	.run(function($injector) {
		window.injector = $injector;
		// console.log('run')
	})
	.run(function(UibmodalService) {
		// UibmodalService.init();
		// UibmodalService will listen to events from the event bus, so it has to be injected
	})
	.config(function($locationProvider) {
		// console.log('config')
		$locationProvider.html5Mode(true);
		$locationProvider.hashPrefix('');
	})
	.config(function($httpProvider) {
		// handle application-wide network errors
		$httpProvider.interceptors.push(function($injector, $q, growl) {
			return {
				responseError: function(rejection) {
					let isAbsoluteUrl = (url) => (/^https?:\/\//i).test(url);
					// session expired error (display error message, redirect to login page)
					if (rejection.status == 401) {
						let remote_url = rejection.config.url;
						let local_url = location.protocol + '//' + location.host;
						if (isAbsoluteUrl(remote_url) && remote_url.indexOf(local_url) == -1) {
							// request wasn't to our server, dont logout
							return rejection;
						}
						var $state = $injector.get('$state')
						growl.warning("Session expirée; veuillez vous reconnecter")
						var principal = $injector.get('principal');
						var uiService = $injector.get('UiService');
						ClientService.authenticate(null)
						principal.authenticate(null);
						if ($state.is('admin-login') || $state.is('client-login')) {
							// do nothing; you're already on the right page
							// that's an error arriving late (after we've already navigated to the login page)
						} else if ($state.includes('admin') || $state.includes('admin1')) {
							$state.go('admin-login')
						} else {
							uiService.showClientLoginModal();
						}
						return $q.reject("Session expirée")
							// server connection lost
					} else if (rejection.status == -1) {
						growl.error("Connexion au serveur interrompue")
						return $q.reject(rejection.data)

					} else { // just forward the rejection
						return rejection
					}
				},
			}
		})
	})
	.config(function(growlProvider) {
		growlProvider.onlyUniqueMessages(true);
		growlProvider.globalTimeToLive(2000);
		growlProvider.globalTimeToLive({
			// error: -1 even errors have ttl
		})
		growlProvider.globalDisableCountDown(true);
	})
	// authentication & authorization events & app-wide user status & i18n
	.run(function($rootScope, principal, authorization, EVENTS, $state, growl,
		$stateParams, UiService) {
		moment.locale('fr')

		$rootScope.breadcrumbs = [];
		$rootScope.$stateParams = $stateParams

		// preload identities to know check if user/client navbar can be displayed
		principal.identity()
		ClientService.identity()
		$rootScope.$on('$locationChangeStart',function(ev, url, oldUrl,state,oldState) {
			if (ShopService.shop && url.endsWith(ShopService.shop.ShopId + '/accueil')) {
				$('html, body').animate({scrollTop: 0 }, 1000, 'swing');
				UiService.toggleSidebar(false);
				UiService.toggleCart(false);
			}
		});

		$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
			// console.log('$stateChangeStart',toState,fromState,toParams,fromParams);
			// from BE to FE => force reload
			if (fromState.name.indexOf('admin') != -1 && toState.name.indexOf('admin') == -1) {
				location.reload();
			}
			$rootScope.transitioning = true;
			// track the state the user wants to go to; authorization service needs this
			$rootScope.toState = toState;
			$rootScope.toStateParams = toParams;
			// if the principal is resolved, do an authorization check immediately. otherwise,
			// it'll be done when the state it resolved.
			if (principal.isIdentityResolved()) authorization.authorize();

			// if (toState.redirectTo) {
			// 	event.preventDefault();
			// 	$state.go(toState.redirectTo, toStateParams)
			// }
		});

		$rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error, principal) {
			$rootScope.transitioning = false;
			console.log('Error transitioning to ', toState.name, error)
		})
		$rootScope.$on('$stateNotFound', function(event, toState, toParams, fromState, fromParams) {
			$rootScope.transitioning = false;
			growl.error("La page '" + toState.to + "' n'existe pas")
			console.log('State not found ', toState.to, event)
		})

		$rootScope.$on('$stateChangeSuccess', function(ev,toState,toParams,fromState,fromParams) {
			if (toState != fromState) {
				// console.log('$stateChangeSuccess=>scrollTop(0)')
				$(window).scrollTop(0);
			}
			$rootScope.transitioning = false;
			if (principal.isInRole("superadmin")) {
				$(".superadmin-background").addClass("superadmin-background-active")
			} else {
				$(".superadmin-background").removeClass("superadmin-background-active")
			}
			if ($state.includes('admin') || $state.includes('admin1')) {
				$(".admin-background").addClass("admin-background-active")
			} else {
				$(".admin-background").removeClass("admin-background-active")
			}
		})

		EventBus.$on(EVENTS.shopLoadError,(ShopId)=>{
			growl.error('Ce magasin est inactif');
			$state.go('inactive',{ShopId: ShopId});
		})
	})
	// app-level functionality: side-menu, clear cache, checkout
	.run(function($rootScope, growl, $state, $location) {
		// show cart or return to last shop's carte if no current shop
		$rootScope.isCartPanelOpen = false
		$rootScope.toggleCartPanel = function(state = !$rootScope.isCartPanelOpen) {
			if ($state.includes('carte')) {
				$rootScope.isCartPanelOpen = state
			} else if (ShopService.shop) {
				$location.path(ShopService.shop.ShopId + '/carte');
				$rootScope.isCartPanelOpen = true;
			} else {
				growl.error('Aucun panier');
				// $location.path('/404')
				// $rootScope.isCartPanelOpen = true
			}
		}

	})
